if (!Array.prototype.at) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function(n) { n = Math.trunc(n) || 0; if (n < 0) n += this.length; return (n < 0 || n >= this.length) ? undefined : this[n]; };
  // eslint-disable-next-line no-extend-native
  String.prototype.at = function(n) { n = Math.trunc(n) || 0; if (n < 0) n += this.length; return (n < 0 || n >= this.length) ? undefined : this[n]; };
}
